// TODO: What's the state of this if not connected?

import Link from 'next/link'
import styled from 'styled-components'
import { useAccount, useEnsName } from 'wagmi'
import { getShortenedAddress } from 'web3/chains'
import { ANoUnderline } from '../Links'

const ProfileSpacer = styled.div`
  height: 90px;
`

const ProfileHeaderOuter = styled.div`
  display: flex;
  z-index: 10;
  flex-direction: row;

  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    flex-direction: column;
    align-items: flex-start;
  `}
`

const ProfileImage = styled.img`
  width: 80px;
  height: 80px;

  border-radius: 50%;
  border: 4px solid black;
  filter: drop-shadow(0px -2px 4px rgba(255, 255, 255, 0.24))
    drop-shadow(0px 8px 16px rgba(27, 26, 37, 0.12))
    drop-shadow(0px 4px 12px rgba(27, 26, 37, 0.08));

  margin-right: 24px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-right: 0px;
  `}
`

const PTitle = styled.div`
  font-family: 'Matter';
  font-weight: 700;
  font-size: 32px;

  max-width: 80vw;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  margin-bottom: 4px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-bottom: 0px;
  `}
`

const SeeProfileA = styled(ANoUnderline)`
  font-family: 'Matter';
  font-weight: 400;

  font-size: 18px;

  color: #b8bccf;

  margin-top: 8px;
`

const ProfileText = styled.div`
  //
`

const ProfileHeader = () => {
  const account = useAccount()

  const { data: ensName } = useEnsName({
    address: account?.address,
  })

  if (!account) {
    return <div />
  }

  return (
    <>
      <ProfileHeaderOuter>
        <Link passHref href={{ pathname: '/' }}>
          <ProfileImage src="/images/gobbler-avatar.png" alt="Profile Pic" />
        </Link>
        <ProfileText>
          <PTitle>{ensName ?? getShortenedAddress(String(account.address))}</PTitle>
          {/* <Link
            passHref
            href={{
              pathname: '/user/[userId]',
              query: { userId: String(account.address) },
            }}
          >
            <SeeProfileA>See profile</SeeProfileA>
          </Link> */}
        </ProfileText>
      </ProfileHeaderOuter>
    </>
  )
}

export { ProfileHeader }
